<template>
    <form class="form-horizontal" v-if="veiculo">


        <br/>
        <div class="form-group">
            <label for="habilitar_direcao_noturna" class="col-sm-6 control-label">HABILITAR DIREÇÃO NOTURNA:</label>
            <div class="col-sm-2">
                <combo-true-false :disabled="! edit" id="habilitar_direcao_noturna" v-model="veiculo.habilitar_direcao_noturna"></combo-true-false>
            </div>
        </div>

        <div class="form-group">
            <label for="hora_inicial_noturno" class="col-sm-2 control-label">HORA INÍCIO:</label>
            <div class="col-sm-2">
                <input type="time" :disabled="! edit" id="hora_inicial_noturno" v-model="veiculo.hora_inicial_noturno" class="form-control">
            </div>
            <label for="hora_final_noturno" class="col-sm-2 control-label">HORA FINAL:</label>
            <div class="col-sm-2">
                <input type="time" :disabled="! edit" id="hora_final_noturno" v-model="veiculo.hora_final_noturno" class="form-control" >
            </div>
        </div>

        <div class="form-group">
            <label for="bloqueio_noturno" class="col-sm-6 control-label">BLOQUEAR VEÍCULO AO SAIR:</label>
            <div class="col-sm-2">
                <combo-true-false :disabled="! edit" id="bloqueio_noturno" v-model="veiculo.bloqueio_noturno"></combo-true-false>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-6 col-sm-2">

                <button @click="saveVeiculo()" type="button" class="btn btn-xs btn-block btn-success">
                    <i class="fa fa-save"></i> SALVAR VEÍCULO
                </button>

            </div>
        </div>

    </form>
</template>

<script>
    import ComboTrueFalse from '../../components/combos/ComboTrueFalse';
    import { Suntech, Veiculo } from "../../class";
    import { Bus } from "../../class/bus";
    export default {
        name: "FormDirecaoNoturna",
        props: {
            veiculo: null,
            edit: {
                default: true
            }
        },
        components: {
            ComboTrueFalse
        },
        methods: {
            saveVeiculo () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta direção noturna?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Veiculo.direcaoNoturna(this.veiculo);
                        toastr.success("Direção noturna enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Direção noturna não enviada!");
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>
